<template>
    <div v-if="isCookieToast" class="cookie-toast-wrap" role="alertdialog" aria-modal="true" aria-labelledby="cookie-toast-title">
        <div class="wrapper">
            <div class="cookie-toast">
                <button @click="setOnlyTech()" class="close" :aria-label="localizer.get('App.Common.Close')"><img src="/images/close.svg" width="18" height="18" class="image" :alt="localizer.get('App.Common.Close')" /></button>
                <div class="description">
                    <div class="title" id="cookie-toast-title"><img src="/images/cookie.svg" class="icon" width="32" height="32" alt="" />{{ localizer.get("CookieToast.Common.Title") }}</div>
                    <span v-html="localizer.get('CookieToast.Common.Description', routes.UrlCookiePolicy)"></span>
                </div>
                <div class="links">
                    <div class="item action">
                        <button @click="setCookieToast()" class="button" data-blue>{{ localizer.get("CookieToast.Common.AgreeAll") }}</button>
                    </div>
                    <div class="item tech">
                        <button @click="setOnlyTech()" class="button" data-border>{{ localizer.get("CookieToast.Common.OnlyTechnicians") }}</button>
                    </div>
                    <div class="item custom">
                        <button @click="setCustomize()" class="button" data-border>{{ localizer.get("CookieToast.Common.Customize") }}</button>
                    </div>
                </div>
                <div :class="['customize', !isCustomize ? 'hden' : '']">
                    <div class="list-item">
                        <div class="item">
                            <div class="info" data-full>
                                <div class="type">{{ localizer.get("CookieToast.Common.Technicians") }}</div>
                            </div>
                        </div>
                        <div class="item">
                            <div class="info">
                                <div class="type">{{ localizer.get("CookieToast.Common.Statistics") }}</div>
                            </div>
                            <div class="action">
                                <button v-if="isActivateStatistics" @click="setStatistics()" class="button" data-border>{{ localizer.get("CookieToast.Common.Deactivate") }}</button>
                                <button v-else @click="setStatistics()" class="button" data-border>{{ localizer.get("CookieToast.Common.Activate") }}</button>
                            </div>
                        </div>
                        <div class="item">
                            <div class="info">
                                <div class="type">{{ localizer.get("CookieToast.Common.Profiling") }}</div>
                            </div>
                            <div class="action">
                                <button v-if="isActivateProfiling" @click="setProfiling()" class="button" data-border>{{ localizer.get("CookieToast.Common.Deactivate") }}</button>
                                <button v-else @click="setProfiling()" class="button" data-border>{{ localizer.get("CookieToast.Common.Activate") }}</button>
                            </div>
                        </div>
                    </div>
                    <div class="confirm">
                        <button @click="setCustomCookie()" class="button" data-blue>{{ localizer.get("CookieToast.Common.SavePreferences") }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import CookieHelper from "@Scripts/Infrastructure/CookieHelper";
import Localizer from "@Scripts/Common/Localizer";

const localizer = Localizer;
const routes = (window as any).App.routes;

const isCookieToast = ref(false);
const isCustomize = ref(false);
const isActivateStatistics = ref(false);
const isActivateProfiling = ref(false);
const customizeCookieValues = ref<string[]>(["tech"]);


if (!CookieHelper.isCookiePolicy()) {
    isCookieToast.value = true;
}

function setCookieToast() {
    CookieHelper.setCookiePolicyAll();
    isCookieToast.value = false;
    window.location.reload();
}

function setOnlyTech() {
    CookieHelper.removeCookiePolicyAll();
    isCookieToast.value = false;
    window.location.reload();
}

function setCustomize() {
    isCustomize.value = !isCustomize.value;
}

function setStatistics() {
    isActivateStatistics.value = !isActivateStatistics.value;

    if (isActivateStatistics.value) {
        if (!customizeCookieValues.value.includes("stat")) {
            customizeCookieValues.value.push("stat");
        }
    } else {
        const index = customizeCookieValues.value.indexOf("stat");
        if (index !== -1) {
            customizeCookieValues.value.splice(index, 1);
        }
    }
}

function setProfiling() {
    isActivateProfiling.value = !isActivateProfiling.value;

    if (isActivateProfiling.value) {
        if (!customizeCookieValues.value.includes("profile")) {
            customizeCookieValues.value.push("profile");
        }
    } else {
        const index = customizeCookieValues.value.indexOf("profile");
        if (index !== -1) {
            customizeCookieValues.value.splice(index, 1);
        }
    }
}

function setCustomCookie() {
    CookieHelper.setCookie("ckp", customizeCookieValues.value.join("|"), 365);
    isCookieToast.value = false;
    window.location.reload();
}
</script>